export const maybeGetTestGameSession = (gameSessionId) => {
  const isTest = typeof window !== "undefined" && !!window.Cypress;
  if (!isTest || !gameSessionId) {
    return gameSessionId;
  }
  if (gameSessionId.endsWith("_TEST")) {
    return gameSessionId;
  }
  // ONLY ADD _TEST if not already present
  return `${gameSessionId}_TEST`;
};
